<template>
  <div class="form-wrap">
    <div class="form-content">
      <h1 class="common-header">
        <i class="el-icon-arrow-left" @click="$emit('doSubmit', null, 1)"></i>
        {{ $t('114') }}
      </h1>
      <section>
        <el-button type="primary" @click="openHolidayModal(false)" v-if="$p('menu.work.clock.edit')">{{
          $t('1847')
        }}</el-button>
        <br /><br />
        <el-table ref="table" :data="tableData" border v-load="tableLoading">
          <!-- 名称 -->
          <el-table-column :label="$t('1688')" prop="name"></el-table-column>
          <!-- 日期 -->
          <el-table-column :label="$t('307')" prop="date_list">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.date_list" placement="top-start">
                <p class="ellipsis">{{ scope.row.date_list }}</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$t('70')">
            <template slot-scope="scope">
              <el-button type="text" @click="openHolidayModal(true, scope.row)" v-if="$p('menu.work.clock.edit')">{{
                $t('71')
              }}</el-button>
              <el-button type="text" @click="handleDel(scope.row)" v-if="$p('menu.work.clock.delete')">{{
                $t('65')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </section>
    </div>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.page"
      :page-sizes="[20, 40, 60, 100]"
      :page-size="page.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    >
    </el-pagination>
    <!-- 新建假期规则 -->
    <common-holiday-moadl ref="modal" @updateTable="getTableData" :isEdit="isEdit" />
  </div>
</template>

<script>
import commonHolidayMoadl from './common-holiday-modal'
import { holidayList, holidayDelete } from 'api/Attendance'

export default {
  components: {
    commonHolidayMoadl
  },
  data() {
    return {
      // 编辑或新建
      isEdit: false,
      page: {
        page: 1,
        page_size: 20,
        total: 0
      },
      tableLoading: false,
      tableData: []
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    // 分页相关
    handleSizeChange(v) {
      this.page.page = 1
      this.page.page_size = v
      this.getTableData()
    },
    handleCurrentChange(v) {
      this.page.page = v
      this.getTableData()
    },
    // 打开新建或编辑弹窗
    openHolidayModal(status, row) {
      this.isEdit = status
      this.$refs.modal.visible = true
      // 编辑获取详情
      if (status) {
        this.$nextTick(() => {
          this.$refs.modal.holidayDetail(row.id)
        })
      }
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true
      holidayList(this.page)
        .then(res => {
          const { items, total } = res.data
          this.tableData = items || []
          this.page.total = total
        })
        .finally(() => (this.tableLoading = false))
    },
    // 删除
    handleDel(row) {
      this.$confirm(this.$t('1846'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        confirmButtonClass: 'el-button--mini',
        cancelButtonClass: 'el-button--mini',
        type: 'warning'
      }).then(() => {
        holidayDelete(row).then(() => this.getTableData())
      })
    }
  }
}
</script>
<style scoped lang="scss">
.common-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  width: calc(100% + 50px);
  transform: translateX(-25px) translateY(-2px);
  padding: 0 25px 15px 25px;
  font-size: 16px;
  user-select: none;
  margin-bottom: 22px;
  &::before {
    display: none;
  }
}
</style>
